module.exports = __webpack_public_path__ + "img/guanyuwomenzhengshu.ef66b515.png";